<template>
  <div class="chat-message chat-message__system">
    <div class="tw-flex tw-flex-col">
      <div class="c-message-text">
        <span class="c-message-text__message">
          {{ message }}
        </span>

        <span class="chat-messsage__stamp">{{ chat.stamp }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

// Define props for the chat component
const props = defineProps({
  chat: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const message = computed(() => {
  const { text = "" } = props.chat || {};

  if (Array.isArray(text) && text.length > 0) {
    return text[0];
  }

  return text;
});
</script>

<style lang="scss" scoped>
.chat-message {
  &__system {
    @apply tw-flex tw-max-w-[70%] tw-gap-4 tw-justify-self-center;
  }

  .chat-messsage__stamp {
    @apply tw-text-end tw-text-xs tw-text-slate-500;
  }

  .c-message-text {
    @apply tw-relative tw-flex tw-flex-col tw-rounded tw-bg-cyan-100/50 tw-p-2;

    &__message {
      @apply tw-text-xs;
    }
  }
}
</style>
